export default __webpack_public_path__ + "c6120cb47860553ebead1662a4d5d317.svg";